import { makeObservable } from "mobx";
import type { Api } from "../core/apis";
import { BaseModel, type BaseModelData } from "../core/BaseModel";
import type { Stores } from "../core/stores";

export interface FeedbackModelData extends BaseModelData {
  fromUserId: string;
  fromEmail: string;
  message: string;
}

export default class FeedbackModel extends BaseModel<FeedbackModelData> {
  constructor(stores: Stores, api: Api, data: FeedbackModelData) {
    super(stores, api, data);

    Object.assign(this.data, {
      fromUserId: data.fromUserId ?? "",
      fromEmail: data.fromEmail ?? "",
      message: data.message ?? "Not-set",
    });

    makeObservable(this);
  }
}
